<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择标签"
    top="5vh"
    width="800px"
  >
    <TableSelect ref="tableSelect" :filter="filter" :columns="columns" module="basic" url="snMetaData" @select="selectSnMetaData">
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="标签编号" prop="metaDataNo">
            <el-input v-model.trim="filter.metaDataNo" placeholder="请输入标签编号" />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        metaDataNo: "",
      },
      columns: [
        {
          title: "标签编号",
          key: "metaDataNo",
          width: 100,
          align: "center",
        },
        {
          title: "标签描述",
          key: "metaDataDesc",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      // 清空查询条件
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    // 选择标签
    selectSnMetaData(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },
  },
};
</script>
